import { Component, Input } from '@angular/core';

@Component({
  selector: 'l-dashboard-section-header',
  standalone: true,
  templateUrl: './dashboard-section-header.component.html',
})
export class DashboardSectionHeaderComponent {

  @Input({ required: true })
  public title: string = '';

  @Input({ required: true })
  public subtitle: string = '';

}
